import React, { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { formatCurrencyValue } from '@eika/currency-input';
import { Loader } from '@eika/loader';

import { EiendomsverdiContainerWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import ETakstFormData from '../eiendom/eTakstFormData';

interface Props {
    eiendomsverdi: EiendomsverdiContainerWeb | undefined;
}

const BoligverdiInfoBox: FC<Props> = ({ eiendomsverdi }) => {
    const { boligVerdi } = useTranslation();
    const { control } = useFormContext<ETakstFormData>();
    const eTakst = useWatch({ name: 'eTakst', control });

    if (!eiendomsverdi) return <Loader />;

    return (
        <div className="info-box row-gap ">
            <div className="title">
                {`${eiendomsverdi?.eiendom?.adresse}, ${eiendomsverdi?.eiendom?.postnummer} ${eiendomsverdi?.eiendom?.poststed}`}
            </div>
            {eTakst?.verdi ? (
                <>
                    <div>
                        <span>{`${boligVerdi.infoNyEtakstverdi}: `}</span>
                        <span className="text-bold">{`${formatCurrencyValue(eTakst.verdi)} kr`}</span>
                    </div>
                    {eTakst?.fellesgjeld && (
                        <div>
                            <span>{`${boligVerdi.infoNyEtakstFellesgjeld}: `}</span>
                            <span className="text-bold">{`${formatCurrencyValue(eTakst?.fellesgjeld)} kr`}</span>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <div>
                        <span>{`${boligVerdi.infoAntattBoligverdi}: `}</span>
                        <span className="text-bold">
                            {eiendomsverdi?.eiendom?.eiendomsverdiWeb?.verdi
                                ? `${formatCurrencyValue(eiendomsverdi?.eiendom?.eiendomsverdiWeb?.verdi)} kr`
                                : `${boligVerdi.infoIkkeFunnet}`}
                        </span>
                    </div>
                    {eiendomsverdi?.eiendom?.eiendomsverdiWeb?.fellesgjeld !== null && (
                        <div>
                            <span>{`${boligVerdi.infoAndelFellesgjeld}: `}</span>
                            <span className="text-bold">
                                {formatCurrencyValue(eiendomsverdi?.eiendom?.eiendomsverdiWeb?.fellesgjeld || 0)} kr
                            </span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default BoligverdiInfoBox;
